import { hairSrc } from "./faceReading.js";

const variant = (id, name, image, detail, length = "medium") => ({
  id,
  name,
  image,
  detail,
  length,
});

export const STYLE_FAMILIES = [
  {
    id: "men-curtain",
    gender: "pria",
    name: "Curtain & Comma",
    summary: "Belahan dan fringe yang memberi gerakan horizontal tanpa menambah tinggi berlebihan.",
    shapes: { oval: 5, oblong: 5, heart: 4, diamond: 4, round: 3, square: 3 },
    variants: [
      variant("men-curtain-classic", "Classic Curtain Fringe", "m-a-curtain-fringe-v2.jpg", "Belah tengah klasik dengan fringe jatuh ke kedua sisi."),
      variant("men-curtain-soft", "Soft Curtain Fringe", "m-e-curtain-fringe-v2.jpg", "Curtain ringan dengan ujung lembut di sekitar alis."),
      variant("men-comma-hair", "Korean Comma Hair", "men-korean-comma-reference.jpg", "Fringe melengkung seperti koma dengan sisi yang tetap rapi."),
      variant("men-textured-curtain", "Textured Curtain", "men-textured-curtain.jpg", "Belah tengah dengan tekstur lebih pecah dan natural."),
      variant("men-wavy-curtain", "Wavy Curtain", "men-wavy-curtain.jpg", "Curtain medium dengan gelombang lembut."),
      variant("men-side-curtain", "Side Curtain", "men-side-curtain-reference.jpg", "Fringe panjang yang dibuka ke satu sisi."),
    ],
  },
  {
    id: "men-wolf",
    gender: "pria",
    name: "Wolf Cut",
    summary: "Layer bertahap dan tekstur yang menjaga rambut tebal tetap bergerak.",
    shapes: { oval: 5, oblong: 4, diamond: 5, square: 4, heart: 3, round: 3 },
    variants: [
      variant("men-wolf-short", "Short Wolf Cut", "men-wolf-short-reference.jpg", "Wolf cut pendek dengan layer bertekstur di mahkota dan tengkuk."),
      variant("men-wolf-medium", "Medium Wolf Cut", "men-wolf-medium.jpg", "Wolf cut medium dengan gerakan lembut ke samping."),
      variant("men-wolf-wavy", "Wavy Wolf Cut", "men-wolf-wavy.jpg", "Layer wolf cut dengan gelombang yang terlihat jelas."),
      variant("men-wolf-curly", "Curly Wolf Cut", "men-wolf-curly.jpg", "Wolf cut berikal dengan volume terkendali."),
      variant("men-wolf-shag", "Soft Shag Wolf", "men-wolf-shag.jpg", "Shag berlayer dengan siluet wolf yang lebih halus."),
      variant("men-wolf-mullet", "Modern Wolf Mullet", "men-wolf-mullet.jpg", "Layer pendek di depan dan sedikit lebih panjang di tengkuk."),
    ],
  },
  {
    id: "men-korean-curl",
    gender: "pria",
    name: "Korean Curl & Perm",
    summary: "Gelombang dan ikal lembut untuk menambah tekstur tanpa membuat rambut kaku.",
    shapes: { oval: 5, oblong: 5, square: 4, heart: 4, diamond: 3, round: 3 },
    variants: [
      variant("men-korean-shadow-perm", "Korean Shadow Perm", "men-korean-shadow-perm.jpg", "Ikal lembut berlapis dengan bayangan volume di sisi."),
      variant("men-korean-wave-perm", "Korean Wave Perm", "men-korean-wave-perm.jpg", "Perm bergelombang medium dengan hasil natural."),
      variant("men-korean-volume-perm", "Volume Perm", "men-korean-volume-perm.jpg", "Gelombang ringan untuk mengangkat rambut tanpa quiff tinggi."),
      variant("men-korean-airy-curl", "Airy Curl", "men-korean-airy-curl.jpg", "Ikal ringan dan renggang dengan tekstur berangin."),
      variant("men-korean-comma-perm", "Comma Perm", "men-korean-comma-perm.jpg", "Perm dengan fringe koma yang jelas di depan."),
      variant("men-korean-curly-fringe", "Curly Fringe", "men-korean-curly-fringe.jpg", "Fringe ikal yang jatuh natural ke arah dahi."),
    ],
  },
  {
    id: "men-crop",
    gender: "pria",
    name: "Textured Crop",
    summary: "Potongan pendek bertekstur dengan fringe untuk memberi struktur yang mudah dirawat.",
    shapes: { round: 5, oval: 5, square: 5, heart: 3, diamond: 4, oblong: 4 },
    variants: [
      variant("men-crop-textured", "Textured Crop", "m-a-textured-crop-v2.jpg", "Crop pendek dengan tekstur pecah di bagian atas.", "short"),
      variant("men-crop-french", "French Crop", "m-e-textured-crop-v2.jpg", "Crop dengan fringe pendek menuju dahi.", "short"),
      variant("men-crop-broken-fringe", "Broken Fringe Crop", "men-crop-broken-fringe.jpg", "Crop dengan ujung fringe tidak membentuk garis rata.", "short"),
      variant("men-crop-caesar", "Caesar Crop", "men-crop-caesar.jpg", "Crop pendek dengan arah fringe maju yang rapi.", "short"),
      variant("men-crop-messy", "Messy Crop", "men-crop-messy.jpg", "Crop pendek dengan tekstur matte yang lebih acak.", "short"),
      variant("men-crop-taper", "Crop + Low Taper", "men-crop-taper.jpg", "Crop bertekstur dengan taper rendah di sisi.", "short"),
    ],
  },
  {
    id: "men-side-part",
    gender: "pria",
    name: "Side Part & Taper",
    summary: "Belahan samping yang rapi dengan taper rendah untuk hasil klasik dan proporsional.",
    shapes: { oval: 5, square: 5, heart: 4, oblong: 5, diamond: 4, round: 3 },
    variants: [
      variant("men-side-classic", "Classic Side Part", "m-a-side-part-v2.jpg", "Belahan samping klasik dengan arah sisir natural.", "short"),
      variant("men-side-natural", "Natural Side Part", "men-side-natural.jpg", "Side part lembut tanpa hasil terlalu licin.", "short"),
      variant("men-side-low-taper", "Side Part + Low Taper", "m-a-neat-taper-v2.jpg", "Belahan samping dengan taper rendah yang bersih.", "short"),
      variant("men-side-soft-taper", "Soft Taper", "m-e-neat-taper-v2.jpg", "Taper halus dengan top sedikit lebih panjang.", "short"),
      variant("men-side-swept", "Textured Side-Swept", "men-side-swept-reference.jpg", "Top bertekstur yang diarahkan diagonal ke samping.", "short"),
      variant("men-side-executive", "Executive Contour", "m-e-side-part-v2.jpg", "Side part terstruktur untuk tampilan formal.", "short"),
    ],
  },
  {
    id: "men-crew-buzz",
    gender: "pria",
    name: "Crew & Buzz",
    summary: "Alternatif sangat pendek yang menonjolkan garis kepala dan rahang.",
    shapes: { oval: 5, round: 4, square: 5, heart: 3, diamond: 3, oblong: 2 },
    variants: [
      variant("men-crew-classic", "Classic Crew Cut", "m-a-crew-cut-v2.jpg", "Crew cut pendek dengan top sedikit lebih panjang.", "short"),
      variant("men-crew-taper", "Tapered Crew Cut", "m-e-crew-cut-v2.jpg", "Crew cut dengan transisi taper di sisi.", "short"),
      variant("men-buzz-classic", "Classic Buzz Cut", "m-a-buzz-cut-v2.jpg", "Buzz cut seragam dan sangat pendek.", "short"),
      variant("men-buzz-fade", "Buzz Cut Fade", "m-e-buzz-cut-v2.jpg", "Buzz cut dengan gradasi sisi yang bersih.", "short"),
      variant("men-buzz-soft", "Soft Buzz Cut", "men-buzz-soft.jpg", "Buzz cut sedikit lebih panjang agar tidak terlalu keras.", "short"),
      variant("men-crew-textured", "Textured Crew", "men-crew-textured.jpg", "Crew pendek dengan sedikit tekstur di top.", "short"),
    ],
  },
  {
    id: "women-curtain",
    gender: "wanita",
    name: "Curtain Bangs",
    summary: "Poni dan face framing yang membuka wajah sekaligus menyeimbangkan dahi.",
    shapes: { oval: 5, oblong: 5, heart: 5, diamond: 5, square: 4, round: 3 },
    variants: [
      variant("women-curtain-classic", "Classic Curtain Bangs", "women-curtain-bangs-reference.jpg", "Poni belah tengah yang membuka ke kedua sisi."),
      variant("women-curtain-wispy", "Wispy Curtain Bob", "women-curtain-wispy.jpg", "Curtain bangs tipis yang menyatu dengan bob ringan."),
      variant("women-curtain-face-frame", "Curtain + Face Frame", "women-curtain-face-frame.jpg", "Curtain bangs tersambung ke layer pembingkai wajah."),
      variant("women-curtain-long", "Long Curtain Bangs", "women-curtain-long.jpg", "Poni panjang yang menyatu sampai area pipi."),
      variant("women-curtain-bob", "Curtain Bangs Bob", "women-curtain-bob.jpg", "Bob ringan dengan curtain fringe tipis."),
      variant("women-curtain-shoulder", "Curtain Shoulder Cut", "women-curtain-shoulder.jpg", "Curtain bangs dengan rambut sebahu."),
    ],
  },
  {
    id: "women-wolf",
    gender: "wanita",
    name: "Wolf Cut",
    summary: "Layer dinamis dari mahkota ke ujung untuk tekstur dan gerakan yang lebih ekspresif.",
    shapes: { oval: 5, square: 5, heart: 4, diamond: 4, round: 4, oblong: 3 },
    variants: [
      variant("women-wolf-soft", "Soft Wolf Cut", "women-wolf-soft.jpg", "Wolf cut panjang dengan layer lembut."),
      variant("women-wolf-wavy", "Wavy Wolf Cut", "women-wolf-wavy.jpg", "Layer wolf dengan gelombang lebar."),
      variant("women-wolf-lob", "Wolf Lob", "women-wolf-lob.jpg", "Wolf cut sebahu dengan ujung ringan."),
      variant("women-wolf-shag", "Shaggy Wolf Cut", "women-wolf-shag.jpg", "Wolf cut dengan tekstur shag lebih jelas."),
      variant("women-wolf-long", "Long Wolf Cut", "women-wolf-long.jpg", "Wolf cut panjang dengan layer bertingkat."),
      variant("women-wolf-textured", "Textured Wolf Cut", "women-wolf-textured.jpg", "Wolf cut bertekstur dengan gerakan di sisi."),
    ],
  },
  {
    id: "women-korean-curl",
    gender: "wanita",
    name: "Korean Curl",
    summary: "Ikal dan gelombang salon yang lembut, rapi, dan tetap natural.",
    shapes: { oval: 5, square: 5, oblong: 5, heart: 4, diamond: 4, round: 3 },
    variants: [
      variant("women-korean-c-curl", "Korean C-Curl", "women-korean-c-curl.jpg", "Ujung rambut sebahu melengkung lembut ke dalam."),
      variant("women-korean-s-curl", "Korean S-Curl", "women-korean-s-curl.jpg", "Gelombang S lembut dari tengah sampai ujung."),
      variant("women-korean-loose", "Loose Korean Curl", "women-korean-loose.jpg", "Ikal longgar dengan volume natural."),
      variant("women-korean-airy", "Airy Korean Wave", "women-korean-airy.jpg", "Gelombang ringan dengan ruang di antara ikal."),
      variant("women-korean-medium", "Korean Medium Curl", "women-korean-medium.jpg", "Ikal medium yang rapi di sekitar pipi dan bahu."),
      variant("women-korean-long", "Long Korean Wave", "women-korean-long.jpg", "Gelombang panjang halus untuk hasil salon."),
    ],
  },
  {
    id: "women-bob",
    gender: "wanita",
    name: "Bob",
    summary: "Siluet tegas dari dagu sampai bahu dengan berbagai arah belahan dan tekstur.",
    shapes: { oval: 5, oblong: 5, heart: 5, diamond: 4, square: 4, round: 3 },
    variants: [
      variant("women-bob-classic", "Classic Chin Bob", "women-bob-classic.jpg", "Bob klasik lurus yang berhenti di sekitar dagu.", "bob"),
      variant("women-bob-soft", "Soft Bob", "women-bob-soft.jpg", "Bob dagu dengan ujung lebih lembut.", "bob"),
      variant("women-bob-side", "Side-Part Bob", "women-bob-side.jpg", "Bob dengan belahan samping yang jelas.", "bob"),
      variant("women-bob-swept", "Side-Swept Bob", "women-bob-swept.jpg", "Bob dengan fringe diagonal ke satu sisi.", "bob"),
      variant("women-bob-wispy", "Wispy Bob", "women-bob-wispy.jpg", "Bob ringan dengan ujung dan poni tipis.", "bob"),
      variant("women-bob-textured", "Textured Bob", "women-bob-textured.jpg", "Bob dengan tekstur pecah agar tidak kaku.", "bob"),
    ],
  },
  {
    id: "women-layered",
    gender: "wanita",
    name: "Layered & Butterfly",
    summary: "Layer panjang yang membingkai wajah dan memberi volume terarah di sisi.",
    shapes: { round: 5, square: 5, heart: 5, oval: 5, diamond: 4, oblong: 4 },
    variants: [
      variant("women-layered-butterfly", "Butterfly Layers", "women-layered-butterfly.jpg", "Layer panjang membuka keluar seperti sayap kupu-kupu."),
      variant("women-layered-long", "Long Layers", "women-layered-long.jpg", "Layer panjang bertahap dengan ujung bergerak."),
      variant("women-layered-face", "Face-Framing Layers", "women-layered-face.jpg", "Layer dimulai di pipi dan rahang untuk membingkai wajah."),
      variant("women-layered-soft", "Soft Face Frame", "women-layered-soft.jpg", "Face frame lembut yang menyatu ke rambut panjang."),
      variant("women-layered-shoulder", "Shoulder Layers", "women-layered-shoulder.jpg", "Layer sebahu dengan volume di samping."),
      variant("women-layered-wave", "Layered Shoulder Wave", "women-layered-wave.jpg", "Layer sebahu dengan gelombang lembut."),
    ],
  },
  {
    id: "women-pixie",
    gender: "wanita",
    name: "Pixie & Crop",
    summary: "Potongan pendek dengan tekstur terarah untuk menonjolkan mata dan garis rahang.",
    shapes: { oval: 5, heart: 5, diamond: 5, square: 4, round: 4, oblong: 3 },
    variants: [
      variant("women-pixie-classic", "Classic Pixie", "c-e-pixie.jpg", "Pixie pendek klasik dengan sisi di atas telinga.", "short"),
      variant("women-pixie-soft", "Soft Pixie", "women-pixie-soft.jpg", "Pixie lembut dengan top sedikit lebih panjang.", "short"),
      variant("women-pixie-textured", "Textured Pixie", "women-pixie-textured.jpg", "Pixie dengan tekstur pecah di bagian atas.", "short"),
      variant("women-crop-short", "Short Crop", "women-crop-short.jpg", "Crop sangat pendek dan dekat dengan kepala.", "short"),
      variant("women-pixie-fringe", "Pixie with Fringe", "women-pixie-fringe-reference.jpg", "Pixie pendek dengan fringe ringan.", "short"),
      variant("women-pixie-taper", "Tapered Pixie", "women-pixie-taper.jpg", "Pixie dengan sisi dan tengkuk yang ditaper.", "short"),
    ],
  },
];

function familyScore(family, reading) {
  if (!reading) return 0;
  const primary = family.shapes?.[reading.shape] || 0;
  const secondary = family.shapes?.[reading.secondary] || 0;
  return primary * 2 + secondary;
}

let liveFamilies = STYLE_FAMILIES;

export function setStyleFamilies(families) {
  if (Array.isArray(families) && families.length) liveFamilies = families;
}

export function currentStyleFamilies() {
  return liveFamilies;
}

export function recommendStyleFamilies(reading, gender = "wanita") {
  const families = liveFamilies
    .filter((family) => family.gender === gender)
    .sort((a, b) => familyScore(b, reading) - familyScore(a, reading) || a.name.localeCompare(b.name));
  const aiIds = reading?.aiFamilyIds || [];
  const aiPicked = aiIds.map((id) => families.find((family) => family.id === id)).filter(Boolean);
  return [...aiPicked, ...families.filter((family) => !aiPicked.includes(family))];
}

export function styleVariantImage(style) {
  if (style?.imageUrl) return style.imageUrl;
  return hairSrc(style?.image || "style-crop.jpg");
}

export function allStyleVariants() {
  return liveFamilies.flatMap((family) => family.variants || []);
}
